import Registry from './models/Registry';
import Swup from 'swup';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import './components/Cursor';
import './components/nelmondo';
import './components/Screensaver';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.contextInstance = this.initController(context);

		this.swupEnabled = false;
    
		if (this.swupEnabled) {
      this.swup = this.initSwup();
      this.initSwupHooks();
			this.updateBodyClasses();
    }
  }

  initController(context) {
    context = this.registry.getContext(context);
    return new context();
  }

  initSwup() {
    return new Swup({
      containers: ['#master', '#header'],
      cache: false
    });
  }


  initSwupHooks() {
    this.swup.hooks.on('content:replace', () => {
      this.contextInstance.reinit();
      this.updateBodyClasses();
      //this.webpHandler.process('#master');
    });

    this.swup.hooks.on('visit:start', () => {
      console.log('Swup visit starting. Cleaning up GSAP...');
      if (typeof this.contextInstance.cleanupGSAP === 'function') {
        this.contextInstance.cleanupGSAP();
      }
    });
  }

  updateBodyClasses() {
    const newBodyClassesEl = document.querySelector('#body-classes');
    if (newBodyClassesEl && newBodyClassesEl.dataset.bodyClasses) {
      const newBodyClasses = newBodyClassesEl.dataset.bodyClasses;
      document.body.className = newBodyClasses;

      // Gestisci anche le classi dell'header e nav per il transparent header
      const hasTransparentHeader = newBodyClasses.includes('header-trasparent');
      const header = document.querySelector('#header');
      const nav = document.querySelector('#header nav');

      if (hasTransparentHeader) {
        if (header) header.classList.add('transparent');
        if (nav) nav.classList.add('transparent');
      } else {
        if (header) header.classList.remove('transparent');
        if (nav) nav.classList.remove('transparent');
      }
    }
  }
}

function scrollToHashTarget() {
  if (!location.hash) return;

  let target;
  try {
    target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
  } catch (e) {
    return;
  }
  if (!target) return;

  ScrollTrigger.refresh();

  // Compensa header fisso (e barra admin WP se presente) per posizionamento corretto
  const header = document.querySelector('#header');
  const adminBar = document.getElementById('wpadminbar');
  let offset = 0;
  if (header) offset += header.offsetHeight;
  if (adminBar) offset += adminBar.offsetHeight;
  const extraGap = 20; // spazio aggiuntivo tra header e target

  const targetY = target.getBoundingClientRect().top + window.pageYOffset - offset - extraGap;
  window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
}

document.addEventListener('DOMContentLoaded', () => {
  const context = typeof _gTheme_ !== 'undefined' ? _gTheme_ : {};
  new App(context);
});

window.addEventListener('load', () => {
  // due rAF: aspetta che layout/pin ScrollTrigger si stabilizzi dopo caricamento immagini
  requestAnimationFrame(() => requestAnimationFrame(scrollToHashTarget));
});
